import type { IconSvgObject } from './types';

const Dish01Icon: IconSvgObject = [
  ["path", { d: "M2 17H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 17L3.71479 19.5415C3.95739 20.4041 4.74407 21 5.6401 21H18.3599C19.2559 21 20.0426 20.4041 20.2852 19.5415L21 17", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3.5 14.5C3.6745 10.3308 7.41331 7 12 7C16.5867 7 20.3255 10.3308 20.5 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 7C12 7 13.5 5.96638 13.5 4.69135C13.5 2.43622 10.5 2.43622 10.5 4.69135C10.5 5.96638 12 7 12 7Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Dish01Icon;
